export default __webpack_public_path__ + "static/media/card-m-product@3x.28d5cc14.png";